import type { Filters } from '../state/selected-filters';

interface FilterCountDisplayProps {
  filters: Filters;
}

export function FilterCountDisplay({ filters }: FilterCountDisplayProps) {
  const activeFilterCount = [
    Boolean(filters.coreFilters.dateRange.from),
    Boolean(filters.coreFilters.dateRange.to),
    Boolean(filters.coreFilters.domain),
    Boolean(filters.coreFilters.siteId),
    Object.keys(filters.batteryFilters).length > 0,
    Object.keys(filters.pcsFilters).length > 0,
  ].filter(Boolean).length;

  return (
    <span
      className="text-sm text-gray-500"
      data-testid="system-logs-filter-count"
    >
      Filters ({activeFilterCount})
    </span>
  );
}
